var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.1633 4 4 11.1636 4 20c0 8.8369 7.1633 16 16 16s16-7.1631 16-16c0-8.8364-7.1633-16-16-16m0 8c1.1046 0 2 .8955 2 2 0 1.105-.8954 2-2 2s-2-.895-2-2c0-1.1045.8954-2 2-2m3 16h-6c-.5522 0-1-.4473-1-1 0-.5522.4478-1 1-1h1v-6h-1c-.5522 0-1-.4473-1-1 0-.5522.4478-1 1-1h4c.5522 0 1 .4478 1 1v7h1c.5522 0 1 .4478 1 1 0 .5527-.4478 1-1 1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-circle.fa23ad3e640f0466cad3a12d4ff453e2.svg";